import React, { useState, useEffect, useId } from 'react';
import gsap from "gsap";
const axios = require('axios').default;
import $ from "jquery";
const filterSystem = ({ category, chosenCategories, l, handleFilter, categories }) => {
    const [menu, setMenu] = useState(gsap.timeline());
    useEffect(() => {
        let menu;
        menu = gsap.timeline({ paused: true, onComplete: () => {
            }, onReverseComplete: () => {
            } });
        menu
            .to("#filter-box", { height: "100vh", duration: 0.25, ease: "power2.out" })
            .to("#filter-box > .header", { opacity: 1, duration: 0.25, ease: "power2.out" })
            .to("#filter-box > .body > h3", { opacity: 1, y: 0, duration: 0.2, ease: "power2.out" })
            .to("#filter-box > .body > .fields > div", { stagger: 0.1, opacity: 1, y: 0, duration: 0.2, ease: "power2.out" }, ">-0.05")
            .to("#filter-box > .body > .submit > div > .Button", { stagger: 0.2, opacity: 1, duration: 0.2, ease: "power2.out" }, ">-0.05");
        setMenu(menu);
        return () => {
        };
    }, []);
    const handleSubmit = (e) => {
        e.preventDefault();
        let formData = new FormData(document.querySelector('#filterform'));
        if (formData.get("filter") == null) {
            handleFilter(null);
        }
        else {
            let elm = [];
            formData.forEach(element => {
                elm.push(element);
            });
            handleFilter(elm);
        }
        menu.reverse();
    };
    const clearFilter = (e) => {
        e.preventDefault();
        $("#filter-box input").prop("checked", false);
        handleFilter(null);
        menu.reverse();
    };
    const toggleFilterBox = (e) => {
        e.preventDefault();
        menu.play();
    };
    let choices;
    if (categories.length) {
        choices = categories.map((element) => {
            let id = useId();
            return React.createElement("div", { key: id },
                React.createElement("input", { type: "checkbox", name: "filter", value: element.slug, id: `elm-${id}` }),
                React.createElement("label", { htmlFor: `elm-${id}` }, element.name));
        });
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: `filter-system scheme-${category}` },
            React.createElement("div", { className: 'actions' },
                React.createElement("a", { href: "#filter", onClick: toggleFilterBox },
                    React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "28.381", height: "15.679", viewBox: "0 0 28.381 15.679" },
                        React.createElement("g", { transform: "translate(-15 -869.66)" },
                            React.createElement("g", { transform: "translate(-8.81 -72.16)" },
                                React.createElement("line", { x2: "26.381", transform: "translate(24.81 942.821)", fill: "none", stroke: "#80de86", strokeLinecap: "round", strokeWidth: "2" }),
                                React.createElement("line", { x2: "18.564", transform: "translate(28.718 949.66)", fill: "none", stroke: "#80de86", strokeLinecap: "round", strokeWidth: "2" }),
                                React.createElement("line", { x2: "10.748", transform: "translate(32.626 956.5)", fill: "none", stroke: "#80de86", strokeLinecap: "round", strokeWidth: "2" })))),
                    React.createElement("span", null, l("filterSystemButton"))),
                React.createElement("div", { className: "filters" })),
            React.createElement("div", { className: "filter-box", id: "filter-box" },
                React.createElement("div", { className: 'header wrapped' },
                    React.createElement("h2", null, l("filterBoxTitle"))),
                React.createElement("form", { className: 'body', action: "", method: "post", id: "filterform" },
                    React.createElement("h3", { className: 'wrapped' }, l(category == "dis" ? "filterBoxBodyDis" : "filterBoxBody")),
                    React.createElement("div", { className: `fields wrapped` }, choices),
                    React.createElement("div", { className: "submit" },
                        React.createElement("div", { className: 'wrapped' },
                            React.createElement("button", { className: 'Button white', onClick: clearFilter, dangerouslySetInnerHTML: { __html: l("clearFilters") } }),
                            React.createElement("button", { className: 'Button', onClick: handleSubmit, dangerouslySetInnerHTML: { __html: l("actionFilters") } }))))))));
};
export default filterSystem;
